<div class="flex between-spacer">
  <h3 class="titulo">Remesas</h3>
  <button class="btn-volver" routerLink="/venta/opciones/menu">volver</button>
</div>

<div class="modal-producto-contenido">
  <form [formGroup]="remesaForm" class="flex center-center mb-1">
    <input type="text" formControlName="monto" class="input-producto-qty" />
  </form>

  <div class="row-numeros">
    <button class="btn-numero" (click)="agregarDigito('7')">7</button>
    <button class="btn-numero" (click)="agregarDigito('8')">8</button>
    <button class="btn-numero" (click)="agregarDigito('9')">9</button>
  </div>

  <div class="row-numeros">
    <button class="btn-numero" (click)="agregarDigito('4')">4</button>
    <button class="btn-numero" (click)="agregarDigito('5')">5</button>
    <button class="btn-numero" (click)="agregarDigito('6')">6</button>
  </div>

  <div class="row-numeros">
    <button class="btn-numero" (click)="agregarDigito('1')">1</button>
    <button class="btn-numero" (click)="agregarDigito('2')">2</button>
    <button class="btn-numero" (click)="agregarDigito('3')">3</button>
  </div>

  <div class="row-numeros">
    <button class="btn-numero" (click)="agregarDigito('0')">0</button>
    <button class="btn-numero" (click)="agregarDigito('00')">00</button>
    <button class="btn-numero" (click)="borrarDigito()">
      <i class="fas fa-backspace"></i>
    </button>
  </div>

  <div class="seccion-botones">
    <button class="btn-aceptar" (click)="guardarRemesa()">ACEPTAR</button>
    <button class="btn-eliminar" routerLink="/venta">CANCELAR</button>
  </div>
</div>
